import React from 'react';
import { useAudio } from '../contexts/AudioContext';
import TimelineReferences from './TimelineReferences';

interface Reference {
  id: string;
  start: number;
  end: number;
  type: string;
  content: string;
  title?: string;
  url?: string;
  linkText?: string;
  category?: string;
  context?: string;
  visualSuggestion?: string;
}

interface TimelineReferencesWrapperProps {
  references: Reference[];
  duration: number;
  width: number;
  isDarkMode: boolean;
  viewportStart?: number;
  viewportEnd?: number;
  timeToX?: (time: number) => number;
  xToTime?: (x: number) => number;
  onSelectReference?: (reference: Reference) => void;
  selectedReferenceId?: string | null;
  onAddReference?: (timestamp: number) => void;
  canEdit?: boolean;
  // Drag functionality props
  onDragStart?: (reference: Reference) => void;
  onDragMove?: (reference: Reference, newTime: number) => void;
  onDragEnd?: (reference: Reference, newTime: number) => void;
}

// Wrapper for TimelineReferences that gets currentTime from AudioContext
const TimelineReferencesWrapper: React.FC<TimelineReferencesWrapperProps> = (props) => {
  const { currentTime } = useAudio();
  return <TimelineReferences {...props} currentTime={currentTime} />;
};

export default TimelineReferencesWrapper;
